module.exports = __webpack_public_path__ + "static/media/all_ag_c.3923a11b.tif";